import type { ChangeEvent } from 'react';
/* eslint-disable no-nested-ternary */
import { PaginationProps } from 'antd';
import { OrderDirection, TrialOrderBy, TrialView } from '@data/sdk/match';
import {
  TrialsEmptyState,
  TrialsFiltersList,
  TrialsList,
  TrialsListSkeleton,
  TrialsSearch,
} from './components';

type QuestionsProps = {
  clearAllFilters: () => void;
  count: number | undefined;
  countries: string[];
  handleCategoryIdsChange: (value: string, label?: string) => void;
  handleCountriesChange: (value: string) => void;
  handleLeadSponsorsChange: (value: string, label?: string) => void;
  handleLocationChange: (value: string, label?: string) => void;
  handleOrderByChange: (value: string) => void;
  handleOrderDirectionChange: (value: string) => void;
  handleOverallStatusChange: (value: string) => void;
  handleSearchChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleStatusSwitchChange: (value: boolean) => void;
  isActiveStatus: boolean;
  isTrialsLoading: boolean;
  orderBy: TrialOrderBy;
  orderDirection: OrderDirection;
  overallStatuses: string[];
  paginationParams: PaginationProps;
  searchString: string;
  trials: TrialView[];
};

export const Trials = ({
  count,
  trials,
  orderBy,
  countries,
  searchString,
  orderDirection,
  isActiveStatus,
  overallStatuses,
  isTrialsLoading,
  paginationParams,
  clearAllFilters,
  handleSearchChange,
  handleOrderByChange,
  handleLocationChange,
  handleCountriesChange,
  handleCategoryIdsChange,
  handleLeadSponsorsChange,
  handleStatusSwitchChange,
  handleOverallStatusChange,
  handleOrderDirectionChange,
}: QuestionsProps) => {
  return (
    <div
      style={{ borderLeftStyle: 'solid' }}
      className="w-full min-h-screen border-l border-l-base-200 pb-4"
    >
      <TrialsSearch
        count={count}
        orderBy={orderBy}
        searchString={searchString}
        isActiveStatus={isActiveStatus}
        orderDirection={orderDirection}
        handleSearchChange={handleSearchChange}
        handleOrderByChange={handleOrderByChange}
        handleStatusSwitchChange={handleStatusSwitchChange}
        handleOrderDirectionChange={handleOrderDirectionChange}
      />
      <TrialsFiltersList
        countries={countries}
        overallStatuses={overallStatuses}
        clearAllFilters={clearAllFilters}
        handleLocationChange={handleLocationChange}
        handleCountriesChange={handleCountriesChange}
        handleCategoryIdsChange={handleCategoryIdsChange}
        handleLeadSponsorsChange={handleLeadSponsorsChange}
        handleOverallStatusChange={handleOverallStatusChange}
      />
      {isTrialsLoading ? (
        <TrialsListSkeleton />
      ) : trials.length > 0 ? (
        <TrialsList trials={trials} paginationParams={paginationParams} />
      ) : (
        <TrialsEmptyState />
      )}
    </div>
  );
};
